﻿/**
 * LaserFlow video export route.
 *
 * Navigate to /export/laser-flow to see the full config UI,
 * or pass query params to pre-fill settings:
 *   /export/laser-flow?duration=10&mode=png&color=%23A78BFA&fps=60
 *
 * Both LaserFlow and WebGLExportPage are lazy-loaded — THREE.js (~600 KB)
 * is never bundled into the production build. This route is dev-only.
 */
import { createFileRoute } from "@tanstack/solid-router";
import { lazy } from "solid-js";

const LaserFlow = lazy(() => import("~/components/laser-flow"));
const WebGLExportPage = lazy(() =>
  import("~/components/webgl-export-page").then((m) => ({
    default: m.WebGLExportPage,
  })),
);

export const Route = createFileRoute("/export/laser-flow")({
  component: () => (
    <WebGLExportPage
      component={LaserFlow}
      filenamePrefix="laser-flow"
      outputName="laser-flow.mp4"
      defaultColor="#818CF8"
      componentProps={{
        horizontalBeamOffset: 0.08,
        verticalBeamOffset: -0.2,
        horizontalSizing: 0.4,
        verticalSizing: 3.5,
        fogIntensity: 0.35,
        wispIntensity: 2.0,
        flowStrength: 0.2,
        decay: 1.6,
        falloffStart: 0.8,
        mouseTiltStrength: 0.008,
        flowSpeed: 0.2,
        // Looping mode: set tiling > 1 for a repeating background grid.
        // distortion helps hide the repetition seams.
        tiling: 1,
        distortion: 0,
        loopDuration: 5,
      }}
    />
  ),
});
